export default "__VITE_ASSET__e49ade15__"